if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.pickupVariantId = this.hasAttribute('available') ? this.dataset.variantId : null;

    }

    connectedCallback() {
      if (this.pickupVariantId) this.fetchAvailability(this.pickupVariantId);
    }

    fetchAvailability(variantId) {
      this.clearAvailability();
      this.pickupVariantId = variantId;
      this.dataset.variantId = variantId;
      const controller = new AbortController();
      this.availabilityController = controller;
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith('/')) {
        rootUrl = rootUrl + '/';
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      return fetch(variantSectionUrl, { signal: controller.signal })
        .then(response => {
          if (!response.ok) throw new Error('Pickup availability request failed');
          return response.text();
        })
        .then(text => {
          if (controller.signal.aborted || this.availabilityController !== controller) return;
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);

        })
        .catch(e => {
          if (controller.signal.aborted || this.availabilityController !== controller) return;
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        })
        .finally(() => {
          if (this.availabilityController === controller) this.availabilityController = null;
        });
    }

    clearAvailability() {
      this.pickupVariantId = null;
      this.availabilityController?.abort();
      this.availabilityController = null;
      this.innerHTML = '';
      this.removeAttribute('available');
    }

    disconnectedCallback() {
      const variantId = this.pickupVariantId;
      this.clearAvailability();
      this.pickupVariantId = variantId;
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';

      if (this.querySelector('button')) {
        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('.pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('.pickup-availability-information')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-information').innerHTML;
      this.setAttribute('available', '');

      document.getElementById('Pickup-Availability').innerHTML = sectionInnerHTML.querySelector('.side-availability').innerHTML;

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        document.getElementById('Pickup-Availability').classList.toggle("active");
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');

        evt.preventDefault();
      });
    }
  });
}
